import type { DashboardPeriod } from '~/app/services/organization-manager-dashboard/organization-manager-dashboard.types';
import type { ServiceQualityStatsDto } from './operator-service-quality.types';

type PeriodOverride = {
  sessionSuccess: number;
  rating: number;
  surveys: number;
  urgentSites: number;
  ownedSuccess: number;
  managedSuccess: number;
};

const PERIOD_OVERRIDE: Record<DashboardPeriod, PeriodOverride> = {
  'q1-2026': {
    sessionSuccess: 91,
    rating: 4.0,
    surveys: 980,
    urgentSites: 3,
    ownedSuccess: 94,
    managedSuccess: 93,
  },
  'q2-2026': {
    sessionSuccess: 93,
    rating: 4.1,
    surveys: 1100,
    urgentSites: 2,
    ownedSuccess: 95,
    managedSuccess: 94,
  },
  'q3-2026': {
    sessionSuccess: 94,
    rating: 4.2,
    surveys: 1248,
    urgentSites: 2,
    ownedSuccess: 96,
    managedSuccess: 96,
  },
  'q4-2026': {
    sessionSuccess: 95,
    rating: 4.3,
    surveys: 1320,
    urgentSites: 1,
    ownedSuccess: 97,
    managedSuccess: 96,
  },
  'last-12-months': {
    sessionSuccess: 93,
    rating: 4.15,
    surveys: 4648,
    urgentSites: 2,
    ownedSuccess: 95,
    managedSuccess: 95,
  },
};

export function applyServiceQualityPeriod(
  stats: ServiceQualityStatsDto,
  period: DashboardPeriod,
): ServiceQualityStatsDto {
  const override = PERIOD_OVERRIDE[period];

  return {
    ...stats,
    urgentSiteCount: override.urgentSites,
    sessionSuccess: {
      ...stats.sessionSuccess,
      ratePercent: override.sessionSuccess,
    },
    customerRating: {
      ...stats.customerRating,
      rating: override.rating,
      surveyCount: override.surveys,
    },
    ownedSites: {
      ...stats.ownedSites,
      avgSessionSuccessPercent: override.ownedSuccess,
    },
    managedSites: {
      ...stats.managedSites,
      avgSessionSuccessPercent: override.managedSuccess,
    },
  };
}
